import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Pagination,
} from "@mui/material";

import SaveAltIcon from '@mui/icons-material/SaveAlt';

import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
// import SaveAltIcon from "@mui/icons-material/DownloadOutlined";
import { CustomSuccessButton } from "../../../Global_Component/GlobalButtonComponent";

import { StatusBarClientDashboard } from "../../../Global_Component/customModuleComponent";

const DashboardClient = () => {
  return (
    <Box sx={{ height: "100%", overflowY: "auto", p: 3, bgcolor: "#EDF4F8" }}>
      <Grid sm={12}>
        <StatusBarClientDashboard
          message={
            "this is the only way to handle the situation else it will not work as expected"
          }
        />
      </Grid>

      <Grid
        container
        sm={12}
        sx={{
          my: 2,
          display: "flex",
          alignItems: "stretch", // Ensures children take the same height
          
        }}
        spacing={1.5}
      >
        <Grid item sm={6}>
          <Box
            sx={{
           

              padding: 2,
              backgroundColor: "#FFFFFF",
              width: "100%",
            }}
          >
            {/* Header */}
            <Grid
              sm={12}
              container
              alignItems="center"

              sx={{ mb: 3,p:1, justifyContent: "space-between",borderBottom:"2px solid #9A9A9A" }}
            >
              <Grid
                sm={6}
                sx={{
                 
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{ fontWeight: 600, display: "flex" }}
                >
                  Certificate
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#1976D2",
                    textTransform: "none",
                    fontSize: "12px",
                    height: "24px",
                    minWidth: "50px",
                    padding: "0 8px",
                    marginLeft: 1,
                    lineHeight: "normal",
                    "&:hover": {
                      backgroundColor: "#155A9B",
                    },
                  }}
                >
                  Active
                </Button>
              </Grid>

              <Grid
                sm={6}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  startIcon={<SaveAltIcon sx={{ color: "#0072DA" }} />}
                  sx={{
                    textTransform: "none",
                    color: "#0072DA",
                    
                    minWidth: "fit-content",
                    padding: 0,
                  }}
                >
                  Download Certificate
                </Button>
              </Grid>
            </Grid>

            {/* Content */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <Grid container sx={{ mb: 1 }} direction="column">
                  {/* Certificate Label */}
                  <Typography
                    sx={{
                      
                      fontWeight: 500,
                      color: "#9A9A9A",
                      mb:1, // Add spacing between label and content
                    }}
                  >
                    Certificate Number
                  </Typography>

                  {/* Certificate Number and Icon */}
                  <Grid container alignItems="center">
                    <Typography
                      sx={{  color: "#000000", mr: 1 }}
                    >
                      076019 / 02082023 / 1010
                    </Typography>
                    <FileCopyOutlinedIcon
                      sx={{
                      
                        color: "#9A9A9A",
                        cursor: "pointer",
                      }}
                    />
                  </Grid>
                </Grid>
                <Typography
                  sx={{
                  
                    fontWeight: 500,
                    color: "#9A9A9A",
                    mb: 1,
                  }}
                >
                  Date of Expiry
                </Typography>
                <Typography sx={{  color: "#000000", mb: 1 }}>
                  01 Aug 2024
                </Typography>
                <Typography
                  sx={{
                    
                    fontWeight: 500,
                    color: "#9A9A9A",
                    mb: 1,
                  }}
                >
                  Certificate for
                </Typography>
                <Typography sx={{  color: "#000000" }}>
                  KAY-EM Luxury hotels & resorts
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src="https://tse4.mm.bing.net/th?id=OIP.-rxDaA6QAIolP4WYggpf9AAAAA&pid=Api&P=0&h=180" // Dummy QR Code
                    alt="QR Code"
                    style={{
                      width: "100px",
                      height: "100px",
                      marginBottom: "8px",
                    }}
                  />
                  <Button
                    startIcon={<SaveAltIcon />}
                    sx={{
                      textTransform: "none",
                      color: "#1976D2",
                      minWidth: "fit-content",
                      padding: 0,
                    }}
                  >
                    Download QR
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Footer */}
            <Box sx={{ textAlign: "right", mt: 2 }}>
              <CustomSuccessButton label={"View Detail"} />
            </Box>
          </Box>
        </Grid>
        <Grid item sm={6} >

        <Box
            sx={{
           
                flexGrow: 1,
              padding: 2,
              backgroundColor: "#FFFFFF",
              height: "100%",
            }}
          >
            {/* Header */}
            <Grid
              sm={12}
              container
              alignItems="center"

              sx={{ mb: 3,p:1, justifyContent: "space-between",borderBottom:"2px solid #9A9A9A" }}
            >
              <Grid
                sm={6}
                sx={{
                 
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{ fontWeight: 600, display: "flex" }}
                >
                  Reports
                </Typography>
                
              </Grid>

              <Grid
                sm={6}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  startIcon={<SaveAltIcon sx={{ color: "#0072DA" }} />}
                  sx={{
                    textTransform: "none",
                    color: "#0072DA",
                    
                    minWidth: "fit-content",
                    padding: 0,
                  }}
                >
                  Download All
                </Button>
              </Grid>
            </Grid>

            {/* Content */}
            <Grid container spacing={2} sx={{p:3}}>
              <Grid sm={12} sx={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <Typography
                    sx={{
                      
                      fontWeight: 500,
                      color: "black",
                      mb:1, // Add spacing between label and content
                    }}
                  >
                    R&D and Pre Audit
                  </Typography>

                  <SaveAltIcon sx={{ color: "#0072DA" }} />

              </Grid>

              <Grid sm={12} sx={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <Typography
                    sx={{
                      
                      fontWeight: 500,
                      color: "black",
                      mb:1, // Add spacing between label and content
                    }}
                  >
                    Invoice and Finance Report
                  </Typography>

                  <SaveAltIcon sx={{ color: "#0072DA" }} />

              </Grid>

              <Grid sm={12} sx={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <Typography
                    sx={{
                      
                      fontWeight: 500,
                      color: "black",
                      mb:1, // Add spacing between label and content
                    }}
                  >
                     Audit report
                  </Typography>

                  <SaveAltIcon sx={{ color: "#0072DA" }} />

              </Grid>


              <Grid sm={12} sx={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <Typography
                    sx={{
                      
                      fontWeight: 500,
                      color: "black",
                      mb:1, // Add spacing between label and content
                    }}
                  >
                  R&D and post audit
                  </Typography>

                  <SaveAltIcon sx={{ color: "#0072DA" }} />

              </Grid>

              <Grid sm={12} sx={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <Typography
                    sx={{
                      
                      fontWeight: 500,
                      color: "black",
                      mb:1, // Add spacing between label and content
                    }}
                  >
                  sharia
                  </Typography>

                  <SaveAltIcon sx={{ color: "#0072DA" }} />

              </Grid>
             
            </Grid>

           
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardClient;
